/* src/app/quick-access/quick-access.component.scss */
/*# sourceMappingURL=quick-access.component.css.map */
